import React, { useState } from 'react';

export default function CityPoolHeader({
  cities = ['Indore', 'Pune', 'Mumbai', 'Pushkar'],
  activeCity: propActiveCity,
  onCityChange,
}) {
  const [selectedCity, setSelectedCity] = useState(propActiveCity || 'Indore');

  const handleCityClick = (city) => {
    setSelectedCity(city);
    if (onCityChange) onCityChange(city);
  };

  return (
    <div
      style={{
        display: 'flex',
        alignItems: 'center',
        gap: '6px',
        overflowX: 'auto',
        paddingBottom: '2px',
        width: '100%',
        fontFamily: 'var(--font-sans)',
      }}
    >
      {cities.map((city) => {
        const isSelected = selectedCity === city;
        const isPushkar = city === 'Pushkar';

        let pillStyle = {
          borderRadius: '9999px',
          padding: '6px 16px',
          fontSize: '0.82rem',
          fontWeight: isSelected ? 800 : 700,
          cursor: 'pointer',
          transition: 'all 0.2s ease',
          display: 'inline-flex',
          alignItems: 'center',
          justifyContent: 'center',
          border: 'none',
          outline: 'none',
          whiteSpace: 'nowrap',
        };

        if (isPushkar) {
          pillStyle = {
            ...pillStyle,
            background: '#0B0C10',
            border: '1.2px solid #FACC15',
            color: '#FACC15',
            boxShadow: isSelected ? '0 0 10px rgba(250, 204, 21, 0.35)' : '0 0 5px rgba(250, 204, 21, 0.15)',
          };
        } else if (isSelected) {
          pillStyle = {
            ...pillStyle,
            background: '#FFFFFF',
            color: '#0A0A0C',
            boxShadow: '0 2px 8px rgba(255, 255, 255, 0.25)',
          };
        } else {
          pillStyle = {
            ...pillStyle,
            background: 'rgba(255, 255, 255, 0.08)',
            border: '1px solid rgba(255, 255, 255, 0.05)',
            color: '#94A3B8',
          };
        }

        return (
          <button
            key={city}
            style={pillStyle}
            onClick={() => handleCityClick(city)}
          >
            {city}
          </button>
        );
      })}
    </div>
  );
}
